import { Record } from "immutable";

export type ContentOptionsType = {
  sequential: boolean;
  exercise: boolean;
};

export type OptionalContentOptionsType = Partial<ContentOptionsType>;

const defaultContentOptions: ContentOptionsType = {
  sequential: false,
  exercise: false
};

export default class ContentOptions extends Record(defaultContentOptions) {}
